import Fingerprint2 from 'fingerprintjs2'

export const createFingerPrint = (cb: any) => {
  const options = {
    excludes: {
      screenResolution: true,
      userAgent: true,
      localStorage: true,
      sessionStorage: true,
      availableScreenResolution: true,
      enumerateDevices: true,
      pixelRatio: true,
      adBlock: true
    }
  }
  const fingerprint = Fingerprint2.get(options, (components: any) => {
    const values = components.map((components: any) => {
      return components.value
    })
    const id = Fingerprint2.x64hash128(values.join(), 31)
    if (cb) cb(id)
    // 缓存浏览器指纹
  })
}
